module.exports = __webpack_public_path__ + "static/media/ski.c48e4de2.mp3";